/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the  appropriate
// layout file, like app/views/layouts/application.html.erb

// this is to remember all listener on a object
import 'arrive/src/arrive';

import '../design_system';
import '../components';

import '../form'; // async OK

import '../components/modal_or_canvas';
import {} from 'jquery-ujs';

// admin is loaded here but all is chunked
import '../admin';
import '../utm_data';

import('../capacitor/boostrap');
import('../capacitor/back_button');
import('../capacitor_utils');

import('../auth'); // async OK
import('../child_management'); // async OK reste 3 fichier
import('../contract_editor'); // async OK reste timeslot
import('../gist');

import('../marketplace');

import('../subscriptions');
import('../social');

// nounou-top loads the full notification module (web-push + settings);
// other brands reach notifications through the lateral menu (TW-1932).
// eslint-disable-next-line no-undef
if (isNounouTop) {
  require('../notification');
}

import('../controllers');

const jQuery = require('jquery');
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

if (!window.__appClientLoaded) {
  window.__appClientLoaded = true;
  require('../components/event_target_logger');
  require('@hotwired/turbo');
}
